module.exports = __webpack_public_path__ + "static/media/Confirm.40d2e58d.svg";